
import { CalendarEvent, DbCalendarEvent } from "./types";
import { addHours } from "date-fns";

export const mapDbEventToCalendarEvent = (
  dbEvent: DbCalendarEvent,
  clientColorMap: Map<string, string>
): CalendarEvent => {
  // Ottieni il colore associato al cliente se presente
  const clientColor = dbEvent.client_id ? clientColorMap.get(dbEvent.client_id) : undefined;
  
  // Converti la data dal formato UTC a oggetto Date
  const startDate = new Date(dbEvent.start_time);
  
  return {
    id: dbEvent.id || "",
    title: dbEvent.title,
    date: startDate,
    hour: startDate.getHours(),
    minute: startDate.getMinutes(),
    clientId: dbEvent.client_id,
    clientName: dbEvent.client_name || undefined,
    type: dbEvent.type,
    status: dbEvent.status,
    remainingHours: dbEvent.remaining_hours,
    courseId: dbEvent.course_id,
    colorCode: clientColor
  };
};

export const mapCalendarEventToDb = (
  event: Omit<CalendarEvent, "id">
): Omit<DbCalendarEvent, "id"> => {
  // Crea una nuova data basata sulla data dell'evento e sull'ora specificata
  const startDate = new Date(event.date);
  startDate.setHours(event.hour, event.minute || 0, 0, 0);
  
  // Calcola la data di fine (assumiamo che un evento duri 1 ora)
  const endDate = addHours(startDate, 1);
  
  return {
    title: event.title,
    start_time: startDate.toISOString(),
    end_time: endDate.toISOString(),
    client_id: event.clientId,
    client_name: event.clientName,
    course_id: event.courseId,
    type: event.type || "session",
    status: event.status || "approved",
    remaining_hours: event.remainingHours,
  };
};

// Funzione per generare un ID univoco per gli eventi dei corsi
export const generateCourseEventId = (
  courseId: string, 
  date: Date, 
  hour: number, 
  minute: number
): string => {
  // Formattiamo la data nel formato YYYY-MM-DD
  const formattedDate = date.toISOString().split('T')[0];
  // Formattiamo l'ora nel formato HH:MM
  const formattedTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
  
  // Restituiamo un ID strutturato che sarà stabile per lo stesso corso, data e ora
  return `course-${courseId}-${formattedDate}-${formattedTime}`;
};
